import { render, staticRenderFns } from "./ColumnMappingsEditPanelDialog.vue?vue&type=template&id=474431e1"
import script from "./ColumnMappingsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./ColumnMappingsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports